import type { AdminTag, AdminTagIndexItem } from 'src/models/tag';
import type { TagResponse } from 'src/models/apis/tag/tagResponse';

export type AdminTagResponse = Omit<TagResponse, 'tag_type2'> & {
  // 管理タグの tag_type2 はレスポンスに含まれないことがあるため optional とする。
  tag_type2?: string;
};

export type AdminTagIndexResponse = AdminTagIndexItemResponse[];

export type AdminTagIndexItemResponse = AdminTagResponse & {
  tag_movie_num: number;
  created_at_date: string;
};

export const toAdminTag = (response: AdminTagResponse): AdminTag => ({
  id: response.id,
  group1Id: response.group1_id,
  group2Id: response.group2_id,
  group3Id: response.group3_id,
  tagName: response.tag_name,
  tagType1: response.tag_type1,
  tagType2: response.tag_type2,
  updatedAt: response.updated_at,
  createdAt: response.created_at,
});

export const toAdminTagIndexItem = (response: AdminTagIndexItemResponse): AdminTagIndexItem => ({
  ...toAdminTag(response),
  tagMovieNum: response.tag_movie_num,
  createdAtDate: response.created_at_date,
});
